/* OsManager.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "os_manager",
    label: "OS Manager",
    disabled: false,
    app: "GameConsole",
    order: 4, // Deprecated -- Newer solution uses order from index.js
    section: "GameCenter",
    license: ["GLUWARE", "OSM"],
    accessPerm: ["osmAccess"],
    pageTitle: "Gluware OS Manager",
    helpLink: "OS%20Manager/OS-management-overview.htm",
    navIcon: "osm.solution",
    iconName: "branding.osManager",
    lmrbNamespaces: [
        Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.OS_PLAN_EXPLORER_LMRB,
        Registrations.IOT_OS_PLAN_EXPLORER_LMRB,
        Registrations.OS_CATALOG_EXPLORER_LMRB,
        Registrations.PLATFORM_EXPLORER_LMRB,
    ],
    editorNamespaces: [Registrations.DEVICE_INSTANCE_EDITOR],
    platformExplorer: {
        viewNamespaces: [
            Registrations.PLATFORM_EXPLORER_GRID,
            Registrations.PLATFORM_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.PLATFORM_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.PLATFORM_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
            Registrations.PLATFORM_EXPLORER_SWITCH_TO_OS_PLAN,
            Registrations.PLATFORM_EXPLORER_SWITCH_TO_OS_CATALOG,
        ],
        actionNamespaces: [
            Registrations.PLATFORM_EXPLORER_ACTION_CREATE,
            Registrations.PLATFORM_EXPLORER_ACTION_DELETE,
            Registrations.PLATFORM_EXPLORER_ACTION_EDIT,
            Registrations.PLATFORM_EXPLORER_ACTION_ADD_IMAGES,
            Registrations.PLATFORM_EXPLORER_ACTION_ADD_INSTRUCTIONS,
            Registrations.PLATFORM_EXPLORER_ACTION_FIND_IMAGES,
        ],
    },
    deviceExplorer: {
        viewNamespaces: [
            Registrations.DEVICE_EXPLORER_VIEW_GRID,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_PLAN,
            Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG,
        ],
        actionNamespaces: [
            Registrations.DEVICE_EXPLORER_ACTION_CREATE_OS_PLAN,
            Registrations.DEVICE_EXPLORER_ACTION_REBOOT_DEVICE,
            Registrations.DEVICE_EXPLORER_ACTION_ADHOC_QUERY,
            Registrations.DEVICE_EXPLORER_ACTION_REPORT,
            Registrations.DEVICE_EXPLORER_ACTION_EXPORT,
            Registrations.DEVICE_EXPLORER_ACTION_BACKUP,
            Registrations.DEVICE_EXPLORER_ACTION_RESTORE,
            Registrations.DEVICE_EXPLORER_ACTION_LINK_AND_SYNC,
        ],
    },
    iotDeviceExplorer: {
        viewNamespaces: [
            Registrations.IOT_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.IOT_DEVICE_EXPLORER_VIEW_GRID,
            Registrations.IOT_SWITCH_TO_OS_PLAN_EXPLORER,
            Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
            Registrations.IOT_DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER,
            Registrations.IOT_SWITCH_TO_CATALOG_EXPLORER,
        ],
        actionNamespaces: [
            Registrations.IOT_DEVICE_EXPLORER_ACTION_ADD_OS_PLAN,
            Registrations.IOT_DEVICE_EXPLORER_ACTION_REPORT,
        ],
    },
    deviceEditor: {
        viewNamespaces: [
            Registrations.DIE_VIEW_DETAILS,
            Registrations.DIE_VIEW_ACTIVITY,
            Registrations.DIE_VIEW_RESTORE,
        ],
        actionNamespaces: [Registrations.DIE_ACTION_BACKUP],
    },
    odmOsPlatformEditor: {
        viewNamespaces: [
            Registrations.ODM_OS_PLATFORM_EDITOR_VIEW_DETAILS,
            Registrations.ODM_OS_PLATFORM_EDITOR_VIEW_ACTIVITY,
        ],
        actionNamespaces: [Registrations.ODM_OS_PLATFORM_EDITOR_ACTION_DELETE],
    },
    osPlanExplorer: {
        viewNamespaces: [
            Registrations.OS_PLAN_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.OS_PLAN_EXPLORER_GRID,
            Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
            Registrations.OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG,
        ],
        actionNamespaces: [
            Registrations.OS_PLAN_EXPLORER_ACTIONS_CREATE,
            Registrations.OS_PLAN_EXPLORER_ACTIONS_DELETE,
            Registrations.OS_PLAN_EXPLORER_ACTIONS_CLONE,
            Registrations.OS_PLAN_EXPLORER_ACTIONS_EXPORT,
            Registrations.OS_PLAN_EXPLORER_ACTIONS_EDIT,
            Registrations.OS_PLAN_EXPLORER_ACTIONS_RUN,
        ],
    },
    osPlanEditor: {
        viewNamespaces: [
            Registrations.OS_PLAN_EDITOR_VIEW_DETAILS,
            Registrations.OS_PLAN_EDITOR_VIEW_RESULTS,
            Registrations.OS_PLAN_EDITOR_VIEW_ACTIVITY,
        ],
        actionNamespaces: [
            Registrations.OS_PLAN_EDITOR_ACTIONS_DELETE,
            Registrations.OS_PLAN_EDITOR_ACTIONS_RUN,
        ],
    },
    osCatalogExplorer: {
        viewNamespaces: [
            Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_PLAN,
            Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
            Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER,
            Registrations.OS_CATALOG_EXPLORER_GRID,
        ],
        actionNamespaces: [
            Registrations.CATALOG_EXPLORER_ACTION_CREATE,
            Registrations.CATALOG_EXPLORER_ACTION_EDIT,
            Registrations.CATALOG_EXPLORER_ACTION_CLONE,
            Registrations.CATALOG_EXPLORER_ACTION_DELETE,
            Registrations.CATALOG_EXPLORER_ACTION_EXPORT,
        ],
    },
    osCatalogEditor: {
        viewNamespaces: [
            Registrations.OS_CATALOG_EDITOR_VIEW_DETAILS,
            Registrations.OS_CATALOG_EDITOR_VIEW_ACTIVITY,
        ],
        actionNamespaces: [Registrations.OS_CATALOG_EDITOR_ACTIONS_DELETE],
    },
    iotOsPlanExplorer: {
        viewNamespaces: [
            Registrations.IOT_OS_PLAN_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.IOT_OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_PLAN,
            Registrations.IOT_OS_PLAN_EXPLORER_GRID,
            Registrations.IOT_OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG,
        ],
        actionNamespaces: [
            Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_CREATE,
            Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_DELETE,
            Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_CLONE,
            // Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_EXPORT,
            Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_EDIT,
            // Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_RUN,
        ],
    },
    iotOsPlanEditor: {
        viewNamespaces: [
            Registrations.IOT_OS_PLAN_EDITOR_VIEW_DETAILS,
            // Registrations.IOT_OS_PLAN_EDITOR_VIEW_RESULTS,
            Registrations.IOT_OS_PLAN_EDITOR_VIEW_ACTIVITY,
        ],
        actionNamespaces: [
            Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_DELETE,
            Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_DOWNLOAD,
            Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_UPLOAD,
            Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_UPDATE_DEVICE_STATUSES,
        ],
    },
    navOptions: {
        device: {
            name: "Devices",
            options: {
                exp: "device",
            },
            type: "exp",
        },
        iot_device: {
            name: "IoT Devices",
            options: {
                exp: "iot_device",
            },
            type: "exp",
        },
        catalogs: {
            name: "Catalogs",
            checkPref: true,
            pref: "enableCatalogs",
            options: {
                exp: "catalog",
            },
            type: "exp",
        },
        osPlans: {
            name: "OS Plans",
            options: {
                exp: "plan",
            },
            type: "exp",
        },
        iotOsPlans: {
            name: "IoT OS Plans",
            options: {
                exp: "iotplan",
            },
            type: "exp",
        },
        odmOsPlatform: {
            name: "IoT Platforms",
            options: {
                exp: "platform",
            },
            type: "exp",
        },
    },
};
